import * as React from "react";
import type { JSX } from "react";
import * as Styles from "../styles/CompareLegend";
import * as CompareSpecsStyles from "../styles/CompareSpecs";
import { IconWrapper } from "../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import Icon, {
    IconPlusCircle,
    IconTag,
    IconExclamation,
} from "../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { type CompareV2LabelType, CompareV2Label } from "../../../utils/labels";
import { useCompareV2Selector } from "../../../redux/store";
import { NcCompareContext } from "../../../../../common-deprecated/types/NewCarCompareTypes";

type IconType = "check" | "circle" | "dash" | "info" | "tag" | "add";

const legendItems: { id: string; name: string; icon: IconType }[] = [
    { id: "standard", name: "compareBodyLegendStandard", icon: "check" },
    { id: "optional", name: "compareBodyLegendOptional", icon: "circle" },
    { id: "notapplicable", name: "compareBodyLegendNotApplicable", icon: "dash" },
    { id: "exception", name: "compareBodyLegendException", icon: "info" },
    { id: "promotion", name: "compareBodyLegendPromotion", icon: "tag" },
    { id: "optionalpack", name: "compareBodyLegendOptionalPack", icon: "add" },
];

export const getLegendIcon = (icon: IconType): JSX.Element => {
    if (icon === "check") {
        return (
            <IconWrapper iconColor="success">
                <Icon variant="check" />
            </IconWrapper>
        );
    } else if (icon === "circle") {
        return (
            <IconWrapper iconColor="fuelCell">
                <Icon variant="customize" />
            </IconWrapper>
        );
    } else if (icon === "dash") {
        return (
            <IconWrapper iconColor="grey3">
                <Icon variant="minus" />
            </IconWrapper>
        );
    } else if (icon === "info") {
        return (
            <IconWrapper iconColor="grey3">
                <IconExclamation />
            </IconWrapper>
        );
    } else if (icon === "tag") {
        return (
            <IconWrapper iconColor="primaryRed">
                <IconTag />
            </IconWrapper>
        );
    } else if (icon === "add") {
        return (
            <IconWrapper iconColor="grey3">
                <IconPlusCircle />
            </IconWrapper>
        );
    } else throw new Error("Unknown Legend Icon type");
};

const EquipmentLegend = (): JSX.Element => {
    const isLeasing = useCompareV2Selector(
        (state) => state.newCarCompare.ncCompareContext === NcCompareContext.Leasing,
    );

    const items = isLeasing
        ? legendItems.filter((item) => !["optional", "optionalpack"].includes(item.id))
        : legendItems;

    return (
        <CompareSpecsStyles.Wrapper>
            <CompareSpecsStyles.Title>
                <CompareV2Label label="compareBodyEquipment" />
            </CompareSpecsStyles.Title>
            <Styles.Wrapper>
                {items.map((item) => (
                    <Styles.Item key={`legend-${item.id}`}>
                        {getLegendIcon(item.icon)} <CompareV2Label label={item.name as CompareV2LabelType} />
                    </Styles.Item>
                ))}
            </Styles.Wrapper>
        </CompareSpecsStyles.Wrapper>
    );
};

export default EquipmentLegend;
